import { PROJECT_NAME } from '../../config/project';
import useTranslation from '../../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-white dark:bg-dark-800 border-t border-gray-200 dark:border-dark-700 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} {PROJECT_NAME}. {t('layout.madeWithLove')}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
